import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { DateUtils } from '@vectord/utils';

import { setAcademyTopicDate } from 'features/classCreation';
import DateTimeInput from 'components/DateTimeInput';
import styles from './ClassDateTimeInput.module.scss';

function ClassDateTimeInput({ cls, dateOfTopic }) {
  const dispatch = useDispatch();

  const dateInputProps = useMemo(
    () => ({
      fromDate: new Date(),
      // Allow schedule till max next 6 months
      toDate: new Date(Date.now() + 180 * DateUtils.ONE_DAY),
    }),
    []
  );

  const timeInputProps = useMemo(
    () => ({
      menuPortalTarget: document.body,
      classNames: { menuPortal: () => styles.timeDropdown },
      maxMenuHeight: 150,
    }),
    []
  );

  const handleChange = useCallback(
    (newDate) => {
      dispatch(
        setAcademyTopicDate({
          academyTopicId: cls.academy_topic.id,
          dateOfTopic: newDate,
        })
      );
    },
    [cls.academy_topic.id, dispatch]
  );

  return (
    <DateTimeInput
      compact
      dateInputProps={dateInputProps}
      required
      timeInputProps={timeInputProps}
      onChange={handleChange}
      value={dateOfTopic}
    />
  );
}

export default ClassDateTimeInput;
